import { drmDeleteTableData } from "../../service/drmDeleteTableData";
import {
  setDeleteDrmTableDataSuccess,
  setDeleteDrmTableDataFailure,
} from "../reducers/drmtDeleteTableDataSlice";
import { buildRecordOperationMessage } from "./drmOperationMessage";

import { put, takeLatest, call } from "redux-saga/effects";

export function* workerDeleteDrmTableData(action) {
  const { payload } = action;

  try {
    const response = yield call(drmDeleteTableData, [
      payload.deleteData,
      payload.tableName,
      payload.controller,
    ]);

    const combinedPayload = buildRecordOperationMessage(response, {
      failureLabel: "Failed deletions",
      successLabel: "Successful deletions",
    });

    yield put(setDeleteDrmTableDataSuccess(combinedPayload));
  } catch (error) {
    yield put(setDeleteDrmTableDataFailure(error.toString()));
  }
}

function* drmDeleteTableDataSaga() {
  yield takeLatest(
    "deleteDrmtTableData/setDeleteDrmTableData",
    workerDeleteDrmTableData
  );
}

export default drmDeleteTableDataSaga;
